/* src/app/expenses/presenters/expense-list/expense-list.component.scss */
.hide-element {
  display: none;
}
form > div {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  justify-content: flex-start;
  padding-left: 0.5rem;
}
form > div > div {
  flex-basis: 200px;
}
form > div > label {
  padding-right: 0.25rem;
}
ef-user-selector-dropdown .mat-form-field {
  margin-top: -1rem;
}
.process-header {
  font-size: 1rem;
  display: flex;
  justify-content: left;
  justify-items: flex-start;
  width: 90%;
}
mat-dialog-container {
  width: 80vw;
  height: 80vh;
}
p-header > div {
  padding-right: 1rem;
  margin-top: -0.25rem;
}
p-header > div.summary-header {
  padding-top: 0.2rem;
  padding-bottom: 0;
  display: inline;
}
p-header > div.summary-header div {
  display: inline;
  padding-right: 1rem;
}
p-header mat-button-toggle,
p-header button {
  height: 2rem;
  margin-top: -0.5rem;
}
:host ::ng-deep div.p-toolbar .p-button {
  height: 1.75rem;
  font-size: 0.75rem;
  margin-right: 0.25rem;
  line-height: 1.5rem;
  min-width: 5rem;
}
:host ::ng-deep div.p-toolbar .p-button.p-togglebutton {
  font-size: 0.75rem;
}
.legend button {
  min-width: 7rem;
  margin-right: 0;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.2);
  border-radius: 0;
}
.legend button:focus {
  box-shadow: unset;
}
/*# sourceMappingURL=expense-list.component.css.map */
